// extracted by mini-css-extract-plugin
module.exports = {"popup__container":"ConfirmationDialog_popup__container__2nlJM","popupFooter":"ConfirmationDialog_popupFooter__1Ra2C"};